import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { LAB_TEST_REFERENCE_VALUES } from "../../../../utils/constants/labTestReferenceValues";

const fields = [
  { key: "crp", label: "CRP", unit: "mg/L" },
  { key: "hiv", label: "HIV", unit: "-" },
  { key: "hbsag", label: "HBsAg", unit: "-" },
  { key: "vdrl", label: "VDRL", unit: "-" },
  { key: "rafactor", label: "RA Factor", unit: "IU/mL" },
  { key: "hcv", label: "HCV", unit: "-" },
  { key: "hav", label: "HAV", unit: "-" },
  { key: "hev", label: "HEV", unit: "-" },
  { key: "asoTire", label: "ASO Titer", unit: "IU/mL" },
  { key: "widalTest", label: "Widal Test", unit: "-" },
  { key: "salmonellaTyphilO", label: "Salmonella Typhi O", unit: "-" },
  { key: "salmonellaTyphiH", label: "Salmonella Typhi H", unit: "-" },
  { key: "salmonellaParaAH", label: "Salmonella Para A (H)", unit: "-" },
  { key: "salmonellaParaBH", label: "Salmonella Para B (H)", unit: "-" },
  { key: "hPyloriAntibody", label: "H. Pylori Antibody", unit: "-" },
  { key: "hPyloriAntigen", label: "H. Pylori Antigen", unit: "-" },
];

export default function ImmunologyTestReport({ defaultValues, reportTemplate }) {
  if (!defaultValues || Object.keys(defaultValues).length === 0) {
    return <p>डाटा उपलब्ध छैन</p>;
  }
  return (
    <TableContainer>
      <Table classes={{ root: "table-bordered" }} size="small" aria-label="Immunology Test">
        <TableHead classes={{ root: "align-center" }}>
          <TableRow>
            <TableCell>Test</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Reference Value</TableCell>
            <TableCell>Unit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody classes={{ root: "align-center" }}>
          {fields.map(({ key, label, unit }) => (
            defaultValues[key] ? (
              <TableRow key={key}>
                <TableCell>{label}</TableCell>
                <TableCell>{defaultValues[key]}</TableCell>
                <TableCell>{LAB_TEST_REFERENCE_VALUES[reportTemplate]?.[key]?.reference || "-"}</TableCell>
                <TableCell>{unit}</TableCell>
              </TableRow>
            ) : null
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
